import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Республика Беларусь';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>

                    <h4>Карты:</h4>
                    <ul>
                        <li>Карта - <a href={require('./../att/Maps/RepublicOfBelarus/01.swf')} download>SWF</a></li>
                    </ul>
                </div>
            </div>
        </>
    );
}